import { extend } from "vee-validate/dist/vee-validate.full.esm";

extend('password', {
    params: ['target'],
    validate(value, { target }) {
        return value === target;
    },
    message: 'As senhas não coincidem'
});
